import styles from '@/styles/productDetail/AddPurchase.module.scss'
import { Button, Select, message, Image } from 'antd';
import { useState } from 'react';
import { addToCart } from '@/utils/addTocart'
import NotifyMe from './NotifyMe';
import { getToken } from '@/utils/auth';

interface PictureItem {
  thumbnailUrl: string;
  imageHDUrl: string;
}

interface ReviewData {
  avgRank: number;
  total: number;
  summary: any;
}

interface paymentMethodItem {
  paymentName: string;
  paymentIcon: string;
}

interface ProductDetailData {
  name: string;
  productID: number;
  enabled: number;
  discontinued: number;
  price: number;
  promotionPrice: number;
  normalPrice: number;
  promotionTypeID: string | number;
  inStock: number;
  freeShipping: number;
  preSales: number;
  preSalesDate: string;
  isEmailOnly: boolean;
  isNew: number | undefined;
  isGroup: number;
  onSale: number;
  reduced: number;
  pictures: PictureItem[];
  newThumbnail: string;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    discountPercent: string;
    ebaySync: number;
  };
  review: ReviewData | null | undefined;
  paymentMethod: paymentMethodItem[];
  currentTime: string;
}

interface QuantityOptions {
  value: number;
  label: string | number;
}

interface Props {
  productDetailData?: ProductDetailData | null
  quantityNum: number;
  handleQuantityChange: Function;
  quantityOptions: QuantityOptions[];
}

export default function AddPurchase({ productDetailData, quantityNum, handleQuantityChange, quantityOptions }: Props) {

  /**
   *  stockStatus
   *  1 In stock
   *  2 Almost sold out
   *  3 Sold out
   *  4 Pre-order
   *  5 Unavailable
   */
  let stockStatus: number = 1
  let stockText = ""
  let iconStyles = ""

  if (productDetailData?.preSales) {
    iconStyles = styles['green']
    stockText = "Pre-order"
    stockStatus = 4

  } else {
    if (productDetailData?.inStock || productDetailData?.inStock == 0) {
      const stock = productDetailData.inStock
      if (stock > 5) {
        stockStatus = 1
        stockText = "In stock"
        iconStyles = styles['green']
      } else if (stock > 0) {
        stockStatus = 2
        stockText = "Almost sold out"
        iconStyles = styles['almost']
      } else {
        if (productDetailData.discontinued && !productDetailData?.enabled && !productDetailData?.inStock) {
          // 禁售
          stockStatus = 5
          stockText = "Sold out"
          iconStyles = styles['soldOut']
        } else {
          // notify me
          stockStatus = 3
          stockText = "Sold out"
          iconStyles = styles['soldOut']
        }
      }
    }
  }

  const [btnloading, setBtnLoading] = useState(false)

  const addToCartCallBack = (response: any) => {
    if (response != "error") {
      window.location.href = "/viewcart"
    } else {
      message.error("Error")
    }
    setBtnLoading(false)

  }

  // notifyMe弹窗控制
  const [isNotifyMeOpen, setisNotifyMeOpen] = useState(false);
  const openNotifyMe = () => {
    setisNotifyMeOpen(true);
  };

  const closeNotifyMe = () => {
    setisNotifyMeOpen(false);
  };

  // PRE-ORDER NOW
  function preOrderNow(productID: string | number | undefined) {
    const href = `/checkout?p=${productID}&t=${1}`
    if (getToken() == '1') {
      window.location.href = href
    } else {
      window.location.href = `/Login?r=${href}`
    }
  }

  return (
    <div className={styles['addPurchase']} id="addPurchase">
      <h2 className={styles['title']}>{productDetailData?.name}</h2>
      <div className={styles['content']}>
        <div className={styles['goods-box']}>
          <div className={styles['goods-picture-box']}>
            <Image
              className={styles['goods-picture']}
              preview={false}
              width={"100%"}
              height={"100%"}
              alt="addPurchaseImg"
              src={productDetailData?.newThumbnail || ""}
            />
          </div>
          <div className={styles['goodsInfo']}>
            <div className={styles['priceLine']}>
              <div className={styles['price']}>
                <span className={styles['currency']}>$</span>
                <span className={styles['val']}>
                  <b>{productDetailData?.price.toString().split('.')[0]}.</b>
                  <i>{productDetailData?.price.toString().split('.')[1]}</i>
                </span>
              </div>
              {
                productDetailData?.normalPrice
                &&
                <div className={styles['cross-price']}>${productDetailData?.normalPrice}</div>
              }
            </div>
            <div className={styles['quantity-box']}>
              <p>Quantity:</p>
              <div className={styles['quantity-component']}>
                <Select
                  style={{ width: 100 }}
                  value={quantityNum}
                  onChange={(value: number) => { handleQuantityChange(value) }}
                  options={quantityOptions}
                  disabled={quantityOptions.length < 1}
                />
                {/* <InputNumber min={1} max={10} defaultValue={3} onChange={onQuantityChange} /> */}
                <span className={`${styles['stock-icon']} ${iconStyles}`}></span>
                <span className={styles['stock-status']}>{stockText}</span>
              </div>
            </div>
            <p className={styles['gst']}>*GST <i>inc.</i></p>
            {
              (stockStatus === 1 || stockStatus === 2)
              &&
              <Button
                style={{ marginTop: 'auto' }}
                type='primary'
                loading={btnloading}
                onClick={(event: any) => {
                  setBtnLoading(true)
                  addToCart(event, {
                    productID: productDetailData?.productID || "",
                    qty: quantityNum
                  }, addToCartCallBack)
                }
                }>Add to Cart</Button>
            }
            {
              (stockStatus === 3)
              &&
              <Button onClick={openNotifyMe}  type='primary' style={{ marginTop: 'auto' }} >Notify me</Button>
            }

            {
              (stockStatus === 4)
              &&
              <Button style={{ backgroundColor: "#4ba65a", color: "#fff", border: "none", marginTop: "auto" }} onClick={() => { preOrderNow(productDetailData?.productID) }}>
                PRE-ORDER NOW
              </Button>
            }
            
            {
              (stockStatus === 5)
              &&
              <Button type='primary' style={{ marginTop: 'auto' }} >Unavailable</Button>
            }

          </div>
        </div>

        <div className={styles['line']}></div>

        <div className={styles['tip-box']}>
          <p className={styles['p1']}>Thank you</p>
          <p className={styles['p2']} style={{ marginBottom: 0 }}>for viewing this product.</p>
          {
            !!(productDetailData && productDetailData?.inStock > 0)
            &&
            <>
              <p className={styles['p2']}>To purchase this product, </p>
              <p className={styles['p3']}>click &quot;Add to Cart&quot;.</p>
            </>
          }
        </div>
      </div>
      {isNotifyMeOpen && <NotifyMe onClose={closeNotifyMe} isWholesaleOpen={isNotifyMeOpen} productID={productDetailData?.productID} />}
    </div>
  )
}